import { Component, OnInit } from '@angular/core';
import { ViewController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { EventData } from '../../../providers/event';
import { TranslateCodePipe } from '../../../pipes/translate';
import { IClient } from '../../../models/client.model';
import { INote } from '../../../models/notes.model';
import { IUser } from '../../../models/user.model';
import { AnalyticsData, _ACTIONS } from '../../../providers/analytics';

const componentName = 'NoteDetailModal';

@Component({
  selector: 'modal-note-detail',
  templateUrl: 'note-detail.modal.html'
})
export class NoteDetailModal implements OnInit {

  client: IClient;
  note: INote;
  user: IUser;

  constructor(
    public viewCtrl: ViewController,
    private navParams: NavParams,
    private eventProvider: EventData,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private analytics: AnalyticsData,
    private translatePipe: TranslateCodePipe
  ) { }

  ngOnInit() {
    this.client = this.navParams.get('client');
    this.note = this.navParams.get('note');
    this.user = this.navParams.get('user');
  }

  async removeNote() {
    this.alertCtrl.create({
      title: await this.translatePipe.transform('Remove'),
      message: await this.translatePipe.transform('Are you sure?'),
      buttons: [
        { text: await this.translatePipe.transform('Cancel'), role: 'cancel' },
        {
          text: await this.translatePipe.transform('Accept'), role: 'cancel', handler: () => {
            this.eventProvider.removeNote(this.client.id, this.user.info.id, this.note.id)
              .then(() => {
                this.analytics.savePageTrackOnFirestore(
                  componentName,
                  _ACTIONS.delNote,
                  this.navParams.get('uidTrack'),
                  { noteId: this.note.id }
                );
                return this.viewCtrl.dismiss()
              })
              .then(async () => this.toastCtrl.create({ message: await this.translatePipe.transform('Note removed'), duration: 3000, position: 'bottom' }).present());
          }
        }
      ]
    }).present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/notes/note-detail/note-detail.modal.ts